export default __webpack_public_path__ + "static/media/12.ae33f622.png";